import type { ComicItem } from './types';

export interface ComicCategory {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

export const categories: ComicCategory[] = [
  { id: '1', name: '恋爱', slug: 'love', icon: 'ri-heart-line' },
  { id: '2', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: '3', name: '动作', slug: 'action', icon: 'ri-fire-line' },
  { id: '4', name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { id: '5', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: '6', name: '恐怖', slug: 'horror', icon: 'ri-ghost-line' },
  { id: '7', name: '耽美', slug: 'bl', icon: 'ri-heart-2-line' },
  { id: '8', name: '剧情', slug: 'drama', icon: 'ri-movie-line' },
];

export const comics: ComicItem[] = [
  {
    id: '1',
    title: '我独自升级',
    slug: 'solo-leveling',
    author: 'Chugong',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20blue%20eyes%2C%20holding%20a%20dagger%2C%20dark%20shadow%20army%20behind%20him%2C%20dramatic%20lighting%2C%20clean%20background%2C%20high%20quality%20anime%20art%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '十年前，世界上突然出现了连接异次元与这个世界的"门"，随之也出现了被称为"猎人"的觉醒者。作为人类最弱兵器的E级猎人成振宇，在一次任务中遭遇了双重地下城，并在濒死之际获得了神秘系统的力量，成为了可以无限成长的"玩家"，从此开启了一段逆袭成最强猎人的传奇故事。',
    rating: 9.7,
    views: 1580000,
    chapters: 179,
    status: 'completed',
    tags: ['热血', '逆袭', '系统流', '战斗'],
    updateDate: '2024-12-20',
    isHot: true,
    isNew: false,
    rank: 1,
    content: '',
  },
  {
    id: '2',
    title: '女神降临',
    slug: 'true-beauty',
    author: 'Yaongyi',
    category: 'love',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20female%20student%20with%20long%20brown%20hair%20and%20perfect%20makeup%2C%20holding%20a%20cosmetic%20brush%2C%20soft%20pink%20background%20with%20floating%20makeup%20items%2C%20romantic%20atmosphere%2C%20clean%20shojo%20art%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '因为长相丑陋而被同学霸凌的任朱静，通过化妆技巧变成了校园女神。她隐藏着自己的真实面貌，开始了全新的高中生活。在这个过程中，她遇到了两个性格截然不同的男生——高冷学霸李修豪和阳光校草韩书俊，展开了一段关于外貌、爱情与自我认同的青春故事。',
    rating: 9.5,
    views: 2340000,
    chapters: 223,
    status: 'completed',
    tags: ['恋爱', '校园', '化妆', '逆袭'],
    updateDate: '2025-01-15',
    isHot: true,
    isNew: false,
    rank: 2,
    content: '',
  },
  {
    id: '3',
    title: '剑尊归来',
    slug: 'swordmaster-return',
    author: 'LICO',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20male%20swordsman%20with%20silver%20hair%20and%20red%20eyes%2C%20wielding%20a%20glowing%20sword%2C%20martial%20arts%20stance%2C%20dark%20background%20with%20energy%20waves%2C%20dynamic%20action%20pose%2C%20stunning%20anime%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '天下第一剑尊白御真，在与魔教教主的最终决战中陨落。然而当他再次睁开眼睛时，发现自己回到了二十年前的少年时代。带着前世的记忆和绝顶武功，他决定彻底改变命运，消灭所有曾经的敌人，守护那些前世没能保护的人，开启了一段霸气逆天的复仇与守护之旅。',
    rating: 9.6,
    views: 1890000,
    chapters: 156,
    status: 'ongoing',
    tags: ['武侠', '重生', '复仇', '爽文'],
    updateDate: '2025-03-08',
    isHot: true,
    isNew: true,
    rank: 3,
    content: '',
  },
  {
    id: '4',
    title: '全知读者视角',
    slug: 'omniscient-reader',
    author: 'sing N song',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20a%20white%20coat%20holding%20a%20smartphone%2C%20standing%20in%20a%20post%20apocalyptic%20cityscape%2C%20constellations%20in%20the%20sky%2C%20sci-fi%20fantasy%20blend%2C%20dramatic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '平凡的上班族金独子，是连载了10年的网文《在灭亡世界中生存的三种方法》的唯一读者。当这部小说在现实世界中开始上演时，身为唯一知道故事结局的人，他必须利用自己对剧情的了解，在这个末日般的世界中生存下去，并改写所有人的命运。',
    rating: 9.8,
    views: 3210000,
    chapters: 210,
    status: 'ongoing',
    tags: ['末世', '系统流', '智斗', '群像'],
    updateDate: '2025-03-12',
    isHot: true,
    isNew: true,
    rank: 1,
    content: '',
  },
  {
    id: '5',
    title: '甜蜜家园',
    slug: 'sweet-home',
    author: 'Kim Carnby',
    category: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20with%20tired%20eyes%20in%20a%20dark%20apartment%20hallway%2C%20monster%20shadows%20looming%2C%20survival%20horror%20atmosphere%2C%20dim%20lighting%2C%20tense%20mood%2C%20thriller%20vibe&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '因校园暴力而封闭自我的高中生车贤秀，在失去家人后搬到了一栋老旧公寓。就在他决定结束自己生命的那天，公寓内突然爆发了可怕的怪物化事件。被困在公寓里的居民们必须团结起来，对抗无处不在的怪物，在绝望中寻找生存的希望。',
    rating: 9.4,
    views: 2750000,
    chapters: 140,
    status: 'completed',
    tags: ['恐怖', '生存', '怪物', '人性'],
    updateDate: '2024-11-30',
    isHot: false,
    isNew: false,
    rank: 5,
    content: '',
  },
  {
    id: '6',
    title: '她的私生活',
    slug: 'her-private-life',
    author: 'Kim Sung-yeon',
    category: 'love',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20female%20art%20curator%20in%20a%20gallery%2C%20warm%20lighting%2C%20romantic%20office%20setting%2C%20professional%20yet%20charming%20vibe%2C%20soft%20colors&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '美术馆策展人成德美，表面上是一位干练优雅的职场女性。但实际上，她是一名狂热的偶像追星族，私下经营着人气偶像的粉丝站。当新任馆长莱恩·金发现她的秘密后，两人之间展开了一段搞笑又甜蜜的办公室罗曼史。',
    rating: 9.2,
    views: 980000,
    chapters: 98,
    status: 'completed',
    tags: ['恋爱', '职场', '搞笑', '追星'],
    updateDate: '2024-09-15',
    isHot: false,
    isNew: false,
    rank: 7,
    content: '',
  },
  {
    id: '7',
    title: '神之塔',
    slug: 'tower-of-god',
    author: 'SIU',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20boy%20climbing%20a%20massive%20mysterious%20tower%2C%20fantasy%20world%20with%20floating%20islands%2C%20adventure%20theme%2C%20epic%20scale%2C%20vibrant%20colors%2C%20grand%20adventure&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '在一个被神秘高塔支配的世界里，少年二十五夜为了追寻唯一的朋友蕾哈尔，进入了这座充满危险与奇迹的塔。每登上一层，他都会遇到新的伙伴和敌人，面临着各种残酷的考验。在这座塔中，一切愿望都可以实现，但代价可能是生命本身。',
    rating: 9.5,
    views: 4100000,
    chapters: 580,
    status: 'ongoing',
    tags: ['冒险', '奇幻', '战斗', '长篇'],
    updateDate: '2025-03-15',
    isHot: true,
    isNew: true,
    rank: 4,
    content: '',
  },
  {
    id: '8',
    title: '外貌至上主义',
    slug: 'lookism',
    author: '朴泰俊',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20split%20face%20showing%20an%20overweight%20student%20and%20a%20handsome%20student%2C%20body%20swap%20concept%2C%20dramatic%20contrast%2C%20school%20setting%2C%20social%20commentary%20theme&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '胖墩墩的高中生朴亨锡，因为外表长期遭受校园霸凌。某天他突然发现自己拥有了两具身体——一具是原来肥胖的自己，另一具则是完美帅气的型男。通过切换两具身体，他体验到了截然不同的人生待遇，同时也逐渐看清了这个世界以外貌取人的残酷现实。',
    rating: 9.3,
    views: 3560000,
    chapters: 450,
    status: 'ongoing',
    tags: ['校园', '社会', '成长', '双身'],
    updateDate: '2025-03-10',
    isHot: false,
    isNew: true,
    rank: 6,
    content: '',
  },
  {
    id: '9',
    title: '某天成为公主',
    slug: 'who-made-me-a-princess',
    author: 'Plutus',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20princess%20with%20blonde%20hair%20and%20jewel-like%20eyes%20in%20a%20luxurious%20palace%2C%20royal%20fantasy%20setting%2C%20elegant%20dress%2C%20warm%20golden%20lighting&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '一名现代女性穿越到了她读过的小说中，成为了注定被亲生父亲——冷酷无情的皇帝杀死的公主阿塔纳西娅。为了改变悲惨的命运，她决定从现在开始努力做一个讨人喜欢的公主，想方设法获取父皇的宠爱，展开了一段温馨又惊险的宫廷生存记。',
    rating: 9.6,
    views: 2890000,
    chapters: 125,
    status: 'completed',
    tags: ['穿越', '宫廷', '治愈', '父女'],
    updateDate: '2024-10-20',
    isHot: true,
    isNew: false,
    rank: 3,
    content: '',
  },
  {
    id: '10',
    title: '狂医魔剑',
    slug: 'mad-doctor',
    author: 'Jung Hyun-min',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20doctor%20with%20a%20scalpel%20in%20one%20hand%20and%20surrounded%20by%20medical%20tools%2C%20dark%20antihero%20vibe%2C%20medical%20thriller%20meets%20action%2C%20intense%20expression&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '天才外科医生朴振宇，在一次医疗事故后被吊销执照，沦为黑市医生。他利用自己超凡的医术在地下世界行医，同时追查当年医疗事故背后的真相。医术与武力的完美结合，一部暗黑风格的医疗动作漫画，展现了人性的光明与黑暗。',
    rating: 9.1,
    views: 870000,
    chapters: 89,
    status: 'ongoing',
    tags: ['医疗', '复仇', '暗黑', '动作'],
    updateDate: '2025-02-28',
    isHot: false,
    isNew: false,
    rank: 10,
    content: '',
  },
  {
    id: '11',
    title: '入笼',
    slug: 'trapped',
    author: 'Haemuri',
    category: 'mystery',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20woman%20behind%20bars%20with%20intense%20eyes%2C%20psychological%20thriller%20theme%2C%20dark%20atmosphere%2C%20suspenseful%20mood%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '大学生尹彩雅被绑架囚禁在一栋神秘别墅中，绑匪提出的要求竟然是要她推理出别墅主人死亡的真相。随着时间的推移，她发现这栋别墅里的每个人都隐藏着不可告人的秘密。一部充满反转的心理悬疑漫画，每一话都在颠覆读者的认知。',
    rating: 9.4,
    views: 1560000,
    chapters: 67,
    status: 'ongoing',
    tags: ['悬疑', '囚禁', '推理', '反转'],
    updateDate: '2025-03-05',
    isHot: false,
    isNew: true,
    rank: 8,
    content: '',
  },
  {
    id: '12',
    title: '搞笑一家人',
    slug: 'funny-family',
    author: 'Lee Kwang-min',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20funny%20family%20with%20exaggerated%20expressions%2C%20chaotic%20household%20scene%2C%20bright%20warm%20colors%2C%20comedy%20slice%20of%20life%2C%20playful%20atmosphere&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '讲述了李家一家六口人的爆笑日常生活。从爷爷奶奶的老年恋爱，到父母的婚姻危机，再到三个孩子各自在学校和职场中遇到的奇葩事件，每一个人物都有着自己的笑点和泪点。在搞笑之余，也蕴含着对家庭、亲情和人生的温暖思考。',
    rating: 9.0,
    views: 1230000,
    chapters: 200,
    status: 'completed',
    tags: ['搞笑', '家庭', '日常', '温馨'],
    updateDate: '2024-08-01',
    isHot: false,
    isNew: false,
    rank: 9,
    content: '',
  },
];

export const bannerComics: ComicItem[] = [
  comics[3], // 全知读者视角
  comics[0], // 我独自升级
  comics[2], // 剑尊归来
  comics[6], // 神之塔
];